// compare two objects -> and returns filtered the first object with properties that exist in the second object
export const getFilteredStorageSchemaProps = (storageProperties: Object, schemaProperties: Object): Object | any => {
  const requiredProps = Object.keys(schemaProperties);
  return Object.fromEntries(Object.entries(storageProperties).filter(([key]) => requiredProps.includes(key)));
};
